export default {
  showForeignReviews: state => state.general.showCountryAndForeignReviews,
};
